import { BRAND } from './brand.config';
import { Bento, FaqAccordion, FeatureStrip, FinalCta, Hero, ImageText, Reveal, SectionHead, SecurityBlock, SiteFooter, SiteHeader, Steps, wrap } from './kit';
import { AgendaPreview, CashierPreview, LoyaltyPreview, PanelPreview } from './parts';
import { cn } from '@/lib/utils';

/*
 * Composição da página. Troca de marca: brand.config.tsx (paleta, imagens, textos, ícones, rotas)
 * e os mockups de parts.tsx; kit.tsx e landing.css ficam iguais.
 */

export { SiteHeader, Hero, FeatureStrip, Bento, Steps, SecurityBlock, FaqAccordion, FinalCta, SiteFooter };

/** Rótulos únicos por intenção, usados em todos os pontos da página. */
export const CTA_SIGNUP = BRAND.cta.signup;
export const CTA_LOGIN = BRAND.cta.login;
export const FAQ = BRAND.faq.items;

/** Segunda faixa (4 números): MOCKUP rotulado "exemplo ilustrativo" do painel do dia, nunca resultado de clientes. */
export function PanelSection() {
  const p = BRAND.panel;
  return (
    <section id={p.id} aria-labelledby="lp-painel" className="pb-4 pt-20 lg:pb-8 lg:pt-28">
      <div className={cn(wrap, 'grid items-end gap-8 lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] lg:gap-14')}>
        <Reveal>
          <SectionHead id="lp-painel" title={p.title} intro={p.intro} />
        </Reveal>
        <Reveal delay={1}>
          <PanelPreview />
        </Reveal>
      </div>
    </section>
  );
}

/** Mockups sobrepostos às fotos dos blocos (chave = `visual` em BRAND.blocks). Sempre no canto, longe do rosto do sujeito. */
const VISUALS = {
  // agenda: foto de cadeiras e espelhos, sem pessoas; o cartão sobe no canto inferior esquerdo (bancada)
  agenda: <AgendaPreview compact className="mt-4 lg:absolute lg:-bottom-10 lg:-left-2 lg:mt-0 lg:w-[58%] lg:min-w-[19rem]" />,
  // caixa: recepcionista à esquerda e cliente à direita; o cartão fica no canto inferior direito sobre o balcão e a parede escura
  caixa: <CashierPreview compact className="mt-4 lg:absolute lg:-bottom-10 lg:-right-2 lg:mt-0 lg:w-[50%] lg:min-w-[19rem]" />,
  // fidelidade: cliente no centro; o cartão sobe no canto superior direito, sobre o espelho
  fidelidade: <LoyaltyPreview compact className="mt-4 lg:absolute lg:-right-2 lg:-top-10 lg:mt-0 lg:w-[48%] lg:min-w-[19rem]" />,
} as const;

export function FeatureBlocks() {
  return (
    <>
      {BRAND.blocks.map((b, i) => (
        <ImageText
          key={b.id}
          id={b.id}
          title={b.title}
          text={b.text}
          bullets={b.bullets}
          image={b.image}
          side={b.side}
          ratio={b.ratio}
          alt={i % 2 === 1}
          visual={b.visual ? VISUALS[b.visual] : undefined}
        />
      ))}
    </>
  );
}
